import React from 'react';
import { Flex, Spinner } from '@zillow/constellation';

export default function IdvSpinner() {
  return (
    <Flex
      display="flex"
      flexDirection="column"
      justifyContent="space-around"
      alignItems="center"
      style={{ height: '100%', overflowY: 'auto' }}
    >
      <Spinner size="lg" />
    </Flex>
  );
}
